import { LOGIN_USER, LOGOUT_USER, ERROR, USER_TABLES, USER_TABLE_CUPPINGS, ANOTHER_USER, UPDATE_USER, DELETE_USER, DELETE_TABLE} from '../actions/types'

const defaultState = {
  isLoggedIn: false,
  isLoggedOut: true, 
  loginBtn: true,
  logoutBtn: false,
  user: null,
  anotherUser: null,
  userTables: null,
  userTableCuppings: null,
  error: false,
  error_msg: null
}

function usersReducer(prevState=defaultState, action){
    // console.log("ORIGINAL", prevState, action)

    switch(action.type){
      case LOGIN_USER:
        return {...prevState, isLoggedIn: true, loginBtn: false, logoutBtn: true, user: action.payload, isLoggedOut: false, error: false}
      case LOGOUT_USER:
        return {...defaultState, isLoggedOut: true}
      case USER_TABLES:
        return {...prevState, userTables: action.payload}
      case USER_TABLE_CUPPINGS:
        return {...prevState, userTableCuppings: action.payload}
      case ANOTHER_USER:
        return {...prevState, anotherUser: action.payload}  
      case UPDATE_USER: 
        return {...prevState, user: action.payload, error: false, error_msg: null}
      case DELETE_USER:
        return {...defaultState, isLoggedOut: true}
      case DELETE_TABLE:
        return {...prevState, userTables: prevState.userTables ? prevState.userTables.filter(userTable => {
          return userTable.id !== action.payload.tableId }) : null }  
      case ERROR:
        return  {
          ...prevState,
          error: true,
          error_msg: action.payload,
        }  
      default: 
        return {...prevState, error: false}
    }
  }

export default usersReducer    
  
